// @owners { team: patients }
import { type LightDelivery } from '~shared/types';

export const CLEAR_FETCH_DELIVERIES_ERROR = 'CLEAR_FETCH_DELIVERIES_ERROR';
type ActionClearFetchDeliveriesError = {
  type: typeof CLEAR_FETCH_DELIVERIES_ERROR;
};

export function clearFetchDeliveriesError(): ActionClearFetchDeliveriesError {
  return {
    type: CLEAR_FETCH_DELIVERIES_ERROR,
  };
}

export const CLEAR_DELIVERY_NOTIFICATIONS = 'CLEAR_DELIVERY_NOTIFICATIONS';
type ActionClearDeliveryNotifications = {
  type: typeof CLEAR_DELIVERY_NOTIFICATIONS;
};

export function clearDeliveryNotifications(): ActionClearDeliveryNotifications {
  return {
    type: CLEAR_DELIVERY_NOTIFICATIONS,
  };
}

export const CLEAR_DELIVERIES_ERROR = 'CLEAR_DELIVERIES_ERROR';
type ActionClearDeliveryError = {
  type: typeof CLEAR_DELIVERIES_ERROR;
};

export function clearDeliveriesError(): ActionClearDeliveryError {
  return {
    type: CLEAR_DELIVERIES_ERROR,
  };
}

type ClearDeliveryActions =
  | ActionClearDeliveryNotifications
  | ActionClearDeliveryError
  | ActionClearFetchDeliveriesError;

export const SET_DELIVERIES = 'SET_DELIVERIES';
export type ActionSetDeliveries = {
  type: typeof SET_DELIVERIES;
  payload: LightDelivery[];
};

/**
 * Bridge setter: mirrors the merged React Query deliveries (all + active) into the Redux `deliveries`
 * slice so existing Reselect selectors (getDeliveries → checkout's getOrder, etc.) keep working without
 * a Redux networking action. Replaces the deprecated fetchDeliveries thunk.
 */
export function setDeliveries(deliveries: LightDelivery[]): ActionSetDeliveries {
  return {
    type: SET_DELIVERIES,
    payload: deliveries,
  };
}

export type DeliveryActions = ClearDeliveryActions | ActionSetDeliveries;
